export default __webpack_public_path__ + "static/media/registrais.ae390003.svg";